import * as React from "react";
import { useState, useContext } from "react";
import { useNavigate } from "react-router";
// mui
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
// arcgis
import Point from "@arcgis/core/geometry/Point";
import Graphic from "@arcgis/core/Graphic.js";
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import PolyLine from "@arcgis/core/geometry/Polyline";
import Polygon from "@arcgis/core/geometry/Polygon";
import SpatialReference from "@arcgis/core/geometry/SpatialReference.js";
import * as projection from "@arcgis/core/geometry/projection.js";
import SketchViewModel from "@arcgis/core/widgets/Sketch/SketchViewModel.js";
// assets
import jso from "src/components/UI/lat&long/assets/img/latlong genarat-json-file..png";
import csv from "src/components/UI/lat&long/assets/img/lat&long generate-csv.png";
import geo from "src/components/UI/lat&long/assets/img/lat&long generate-geojson.png";
import draw from "src/components/UI/lat&long/assets/img/lat&long generate-drawing.png";
import clear from "src/components/UI/lat&long/assets/img/lat&long generate-clear-format.png";
import copyy from "src/components/UI/lat&long/assets/img/latlong genarat-copy.png";
import pointz from "src/components/UI/lat&long/assets/img/lat&long generate-points.png";
import styles from "src/components/UI/lat&long/assets/scss/Latlong.module.scss";
import importt from "src/components/UI/lat&long/assets/img/latlong genarat-download.png";
// components
import BasePanel from "src/components/UI/Shared/BasePanel";
// cnfig
import { Symbol } from "src/config/symbol";
import SharedHandler, {
  _GetUrl,
  _GetTitle,
} from "src/components/UI/Shared/handler";
// redux
import { useSelector, useDispatch } from "react-redux";
import { appActions } from "src/store/store";
// data
import Store from "src/data/store";
const store = Store.getInstance();

interface DrawMode {
  geometryType: {
    point: number;
    polyline: number;
    polygon: number;
  };
}
interface LLGProps {}

const LLG = ({}: LLGProps) => {
  const dispatch = useDispatch();
  const activePanel = useSelector((state: any) => state.app.activePanel);

  const navigate = useNavigate();
  const pathname = window.location.pathname;

  const [drawMode, setDrawMode] = useState<DrawMode>({
    geometryType: {
      point: 0,
      polyline: 0,
      polygon: 0,
    },
  });
  const [latLongValues, setLatLongValues] = useState("");
  const [exportFormat, setExportFormat] = useState<string>("GeoJSON");

  const [copySuccess, setCopySuccess] = useState(false);
  const [inputValue, setInputValue] = useState<string>("15");

  const tod = pathname.split("/")[pathname.split("/").length - 1];

  const typeOfDrawing =
    tod === "Points" ? "point" : tod === "Lines" ? "polyline" : "polygon";

  const handleClose = (
    event: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason !== "backdropClick") {
      dispatch(appActions.setActivePanel(undefined));
      dispatch(
        appActions.setSearchString({
          menu1: "",
          menu2: "",
          menu3: "",
          menu4: "",
          menu5: "",
          menu6: "",
        })
      );
      navigate("../..");
    }
  };
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = Number(event.target.value);
    if (!isNaN(value) && value >= 0) {
      setInputValue(event.target.value);
    }
  };
  const createRandomPoints = (
    event: __esri.SketchViewModelCreateEvent,
    inputValue: number,
    graphicsLayer: GraphicsLayer | undefined
  ) => {
    let latLongValues = "";
    var x_max = event.graphic.geometry.extent.xmax;
    var x_min = event.graphic.geometry.extent.xmin;
    var y_max = event.graphic.geometry.extent.ymax;
    var y_min = event.graphic.geometry.extent.ymin;
    for (let j = 0; j < inputValue; j++) {
      let randomLongitude = Math.random() * (x_max - x_min) + x_min;
      let randomLatitude = Math.random() * (y_max - y_min) + y_min;

      let point = new Point({
        x: randomLongitude,
        y: randomLatitude,
        spatialReference: store.MapView?.spatialReference,
      });

      let pointGraphic = new Graphic({
        geometry: point,
        symbol: Symbol.point,
      });
      graphicsLayer?.add(pointGraphic);
      const cs2 = new SpatialReference({
        wkid: 4326,
      });

      const projectedPoint = projection.project(point, cs2) as Point;

      latLongValues += `${projectedPoint.longitude},${projectedPoint.latitude}\r\n`;
    }

    return latLongValues;
  };
  const _DrawPointsHandler = (
    sketchViewModel: SketchViewModel,
    graphicsLayer: GraphicsLayer
  ) => {
    sketchViewModel.defaultCreateOptions.mode = "freehand";
    sketchViewModel.create("rectangle");
    sketchViewModel.on(
      "create",
      function (event: __esri.SketchViewModelCreateEvent) {
        if (event.state === "complete") {
          setLatLongValues((prevValues) => {
            const latLongValues = createRandomPoints(
              event,
              Number(inputValue),
              graphicsLayer
            );
            console.log(latLongValues);
            return prevValues ? prevValues + latLongValues : latLongValues;
          });
          dispatch(appActions.setPreviousNavigation(_GetUrl(2, 0)));
        }
      }
    );
  };
  const _DrawLinesHandler = (sketchViewModel: SketchViewModel) => {
    sketchViewModel.create("polyline");
    sketchViewModel.on(
      "create",
      function (event: __esri.SketchViewModelCreateEvent) {
        if (event.state === "complete") {
          const line = event.graphic.geometry as PolyLine;
          const targetSpatialReference = new SpatialReference({
            wkid: 4326,
          });
          let latLongValues = "";
          const projectedline = projection.project(
            line,
            targetSpatialReference
          ) as PolyLine;
          latLongValues += `${projectedline.paths}\r\n`;
          setLatLongValues((prevValues) =>
            prevValues ? prevValues + latLongValues : latLongValues
          );
          dispatch(appActions.setPreviousNavigation(_GetUrl(2, 1)));
        }
      }
    );
  };
  const _DrawPolygonsHandler = (sketchViewModel: SketchViewModel) => {
    sketchViewModel.create("polygon");
    sketchViewModel.on("create", function (event) {
      if (event.state === "complete") {
        const polygon = event.graphic.geometry as Polygon;
        const targetSpatialReference = new SpatialReference({
          wkid: 4326,
        });
        let latLongValues: string = "";
        const projectedpolygon = projection.project(
          polygon,
          targetSpatialReference
        ) as Polygon;
        latLongValues += `${projectedpolygon.rings}\r\n`;
        setLatLongValues((prevValues) =>
          prevValues ? prevValues + latLongValues : latLongValues
        );
        dispatch(appActions.setPreviousNavigation(_GetUrl(2, 2)));
      }
    });
  };
  const handledraw = () => {
    setDrawMode((prevDrawMode) => {
      const tmp = prevDrawMode;
      let targetLayer: any;
      if (tmp.geometryType[typeOfDrawing] === 0) {
        const graphicsLayer_ = store.createGraphicsLayer(
          tod,
          `data_generator-${typeOfDrawing}s`
        );
        targetLayer = graphicsLayer_;
      } else {
        if (store.MapView) {
          const layer = store.MapView.map.findLayerById(
            `data_generator-${typeOfDrawing}s`
          ) as GraphicsLayer;
          targetLayer = layer;
        }
      }
      const sketchViewModel = new SketchViewModel({
        view: store.MapView,
        layer: targetLayer,
        defaultCreateOptions: {
          mode: "click",
        },
        polylineSymbol: Symbol.polyline as any,
        polygonSymbol: Symbol.polygon as any,
      });
      tmp.geometryType[typeOfDrawing] =
        prevDrawMode.geometryType[typeOfDrawing] + 1;
      if (typeOfDrawing === "point") {
        _DrawPointsHandler(sketchViewModel, targetLayer);
      } else if (typeOfDrawing === "polyline") {
        _DrawLinesHandler(sketchViewModel);
      } else if (typeOfDrawing === "polygon") {
        _DrawPolygonsHandler(sketchViewModel);
      }
      return tmp;
    });
  };

  const handleclear = () => {
    //store.MapView?.map.layers.removeAll();
    const layersToRemove = store.MapView?.map.layers.toArray().filter((x) => {
      return x.id === `data_generator-${typeOfDrawing}s`;
    });
    if (layersToRemove) store.MapView?.map.layers.removeMany(layersToRemove);
    //   graphicsLayer?.graphics.removeAll();
    setDrawMode((prevState) => ({
      ...prevState,
      geometryType: {
        ...prevState.geometryType,
        [typeOfDrawing]: 0,
      },
    }));
    setLatLongValues("");
  };

  const exportAsCSV = async (filename: string) => {
    console.log(latLongValues);
    const fileBlob = SharedHandler.createFileBlobHandler(
      "longitude,latitude\n" + latLongValues,
      "text/csv;charset=utf-8"
    );

    await SharedHandler.saveFile(fileBlob, filename);
  };

  // const handleViewAndCopy = () => {
  //   const textToCopy = content;

  //   if (navigator.clipboard) {
  //     navigator.clipboard
  //       .writeText(textToCopy)
  //       .then(() => {
  //         setCopySuccess(true);
  //         alert("CSV Data has been copied to the clipboard.");
  //       })
  //       .catch((err) => {
  //         console.error("Failed to copy text: ", err);
  //         setCopySuccess(false);
  //       });
  //   } else {
  //     const textArea = document.createElement("textarea");
  //     textArea.value = textToCopy;
  //     textArea.style.position = "fixed";
  //     textArea.style.opacity = "0";
  //     document.body.appendChild(textArea);
  //     textArea.select();

  //     try {
  //       document.execCommand("copy");
  //       setCopySuccess(true);
  //       alert("CSV Data has been copied to the clipboard.");
  //     } catch (err) {
  //       setCopySuccess(false);
  //     } finally {
  //       document.body.removeChild(textArea);
  //     }
  //   }
  // };
  let features: any[] = [];

  function exportAsJSON(filename: string, typeOfDrawing: string): string {
    const pl = latLongValues.trim().split("\r\n");

    let geometryType;
    let features: any[] = [];
    let fields: any[] = [];

    if (typeOfDrawing === "point") {
      geometryType = "esriGeometryPoint";
      fields = [{ name: "OBJECTID" }];

      const formattedPoints = pl.map((point, index) => {
        const [longitude, latitude] = point.split(",").map(Number);
        if (!isNaN(longitude) && !isNaN(latitude)) {
          const con = {
            attributes: { OBJECTID: index + 1 },
            geometry: {
              x: longitude,
              y: latitude,
            },
          };
          features.push(con);
        }
      });
    } else if (typeOfDrawing === "polyline") {
      geometryType = "esriGeometryPolyline";
      fields = [{ name: "OBJECTID" }];

      const paths: any[] = [];
      const po = latLongValues.split("\r\n");

      po.forEach((line, index) => {
        const coords = line.split(",");
        let lio = [];
        for (let i = 0; i < coords.length; i += 2) {
          const longitude = parseFloat(coords[i]);
          const latitude = parseFloat(coords[i + 1]);
          if (!isNaN(longitude) && !isNaN(latitude)) {
            lio.push([longitude, latitude]);
          }
        }

        if (lio.length > 0) {
          paths.push(lio);
          features.push({
            attributes: { OBJECTID: index + 1 },
            geometry: {
              paths: [lio],
            },
          });
        }
      });
    } else if (typeOfDrawing === "polygon") {
      geometryType = "esriGeometryPolygon";
      fields = [{ name: "OBJECTID" }];

      const rings: any[] = [];
      const po = latLongValues.split("\r\n");

      po.forEach((line, index) => {
        const coords = line.split(",");
        let lio = [];
        for (let i = 0; i < coords.length; i += 2) {
          const longitude = parseFloat(coords[i]);
          const latitude = parseFloat(coords[i + 1]);
          if (!isNaN(longitude) && !isNaN(latitude)) {
            lio.push([longitude, latitude]);
          }
        }

        if (lio.length > 0) {
          rings.push(lio);
          features.push({
            attributes: { OBJECTID: index + 1 },
            geometry: {
              rings: [lio],
            },
          });
        }
      });
    } else {
      dispatch(
        appActions.setNotification({
          severity: "error",
          message: "Unsupported geometry type.",
          open: true,
        })
      );
      return "";
    }

    const jsonData = {
      displayFieldName: " ",
      fieldAliases: { OBJECTID: "OBJECTID" },
      geometryType: geometryType,
      spatialReference: {
        wkid: 4326,
        latestWkid: 4326,
      },
      fields: fields,
      features: features,
    };

    const jsonStr = JSON.stringify(jsonData, null, 2);

    const blob = new Blob([jsonStr], { type: "application/json" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = filename;
    a.click();
    return jsonStr;
  }

  function exportAsGeoJSON(feature: any, filename: string): void {
    const geojsonContent =
      "data:text/geojson;charset=utf-8," +
      encodeURIComponent(JSON.stringify(feature));
    const link = document.createElement("a");
    link.setAttribute("href", geojsonContent);
    link.setAttribute("download", filename);
    link.click();
  }

  if (typeOfDrawing === "point") {
    let feat: any[] = [];
    const po = latLongValues.split("\r\n");
    po.forEach((point) => {
      const coords = point.split(",");
      const longitude = parseFloat(coords[0]);
      const latitude = parseFloat(coords[1]);
      if (!isNaN(longitude) && !isNaN(latitude)) {
        const feature = {
          type: "Feature",
          id: feat.length + 1,

          geometry: {
            type: "Point",
            coordinates: [longitude, latitude],
          },
          properties: {
            OBJECTID: feat.length + 1,
          },
        };
        feat.push(feature);
      }
    });

    features = feat;
  } else if (typeOfDrawing === "polygon" || typeOfDrawing === "polyline") {
    let coordinates: any[] = [];

    const po = latLongValues.split("\r\n");
    po.forEach((line, index) => {
      const coords = line.split(",");
      let lio = [];
      for (let i = 0; i < coords.length; i += 2) {
        const longitude = parseFloat(coords[i]);
        const latitude = parseFloat(coords[i + 1]);
        if (!isNaN(longitude) && !isNaN(latitude)) {
          lio.push([longitude, latitude]);
        }
      }

      if (lio.length > 0) {
        coordinates.push(lio);
      }
    });

    let gType = "";

    if (typeOfDrawing === "polygon") {
      gType = "Polygon";
    } else if (typeOfDrawing === "polyline") {
      gType = "LineString";
    } else {
      dispatch(
        appActions.setNotification({
          severity: "error",
          message: "Unsupported geometry type.",
          open: true,
        })
      );
    }

    if (typeOfDrawing === "polygon" || typeOfDrawing === "polyline") {
      if (coordinates.length > 0) {
        for (let i = 0; i < coordinates.length; i += 1) {
          const feature = {
            type: "Feature",
            id: i + 1,
            geometry: {
              type: gType,
              coordinates:
                typeOfDrawing === "polygon" ? [coordinates[i]] : coordinates[i],
            },
            properties: {
              OBJECTID: i + 1,
            },
          };
          features.push(feature);
        }
      }
    }
  }

  const geojson_obj: any = {
    type: "FeatureCollection",
    crs: {
      type: "name",
      properties: {
        name: "EPSG:4326",
      },
    },
    features: features,
  };

  let handleExport = () => {
    if (exportFormat === "GeoJSON") {
      exportAsGeoJSON(geojson_obj, "data.geojson");
    } else if (exportFormat === "JSON") {
      exportAsJSON("data.json", typeOfDrawing);
    } else if (exportFormat === "CSV") {
      exportAsCSV("data.csv");
    }
  };

  const copyToClipboard = (content: string) => {
    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(content)
        .then(() => {
          setCopySuccess(true);
        })
        .catch((err) => {
          setCopySuccess(false);
        });
    } else {
      const textArea = document.createElement("textarea");
      textArea.value = content;
      textArea.style.position = "fixed";
      textArea.style.opacity = "0";
      document.body.appendChild(textArea);
      textArea.select();

      try {
        document.execCommand("copy");
        setCopySuccess(true);
      } catch (err) {
        setCopySuccess(false);
      } finally {
        document.body.removeChild(textArea);
      }
    }
  };

  const handleCopy = () => {
    try {
      if (exportFormat === "GeoJSON") {
        const geojsonString = JSON.stringify(geojson_obj);
        copyToClipboard(geojsonString);
      } else if (exportFormat === "JSON") {
        const jsonString = exportAsJSON("data.json", typeOfDrawing);
        copyToClipboard(jsonString);
      } else if (exportFormat === "CSV") {
        copyToClipboard("latitude,longitude\n" + latLongValues);
      }
    } catch (error) {
      console.error("Error copying content:", error);
    }
  };

  return (
    <BasePanel
      openModal={activePanel === "generator"}
      onClose={handleClose}
      panelName={tod}
    >
      <Button
        className={styles.btn11}
        onClick={handledraw}
        variant="contained"
        disableElevation
      >
        <img className={styles.ico1} src={draw} />
        <span className={styles.text4}>Draw</span>
      </Button>
      <PopupState variant="popover" popupId="demo-popup-menu">
        {(popupState) => (
          <React.Fragment>
            <Button
              className={styles.btn}
              variant="contained"
              {...bindTrigger(popupState)}
            >
              {exportFormat === "GeoJSON" && (
                <span className={styles.text}>
                  {" "}
                  <img className={styles.i1} src={geo} />
                  GeoJSON
                </span>
              )}
              {exportFormat === "JSON" && (
                <span className={styles.tex}>
                  {" "}
                  <img className={styles.i1} src={jso} />
                  JSON
                </span>
              )}
              {exportFormat === "CSV" && (
                <span className={styles.tex}>
                  {" "}
                  <img className={styles.i1} src={csv} />
                  CSV
                </span>
              )}
            </Button>
            <Menu {...bindMenu(popupState)}>
              <MenuItem
                className={styles.menuu}
                onClick={() => {
                  setExportFormat("GeoJSON");
                  popupState.close();
                }}
              >
                <img className={styles.i} src={geo} />
                GeoJSON
              </MenuItem>
              <MenuItem
                className={styles.menuu}
                onClick={() => {
                  setExportFormat("JSON");
                  popupState.close();
                }}
              >
                <img className={styles.i} src={jso} />
                JSON
              </MenuItem>
              <MenuItem
                className={styles.menuu}
                onClick={() => {
                  setExportFormat("CSV");
                  popupState.close();
                }}
              >
                <img className={styles.i} src={csv} />
                CSV
              </MenuItem>
            </Menu>
          </React.Fragment>
        )}
      </PopupState>
      <Button
        className={styles.btn1}
        onClick={handleExport}
        variant="contained"
        disableElevation
      >
        <img className={styles.ico12} src={importt} />
        <span className={styles.text1}>Export</span>
      </Button>

      <Button
        className={styles.btn1}
        onClick={handleCopy}
        variant="contained"
        disableElevation
      >
        <img className={styles.ico1} src={copyy} />
        <span className={styles.text2}>Copy</span>
      </Button>

      <Button
        className={styles.btn2}
        onClick={handleclear}
        variant="contained"
        disableElevation
      >
        <img className={styles.ico1} src={clear} />
        <span className={styles.text3}>Clear</span>
      </Button>

      {typeOfDrawing === "point" && (
        <>
          <h2>Number Of Points</h2>

          <Box component="form" noValidate autoComplete="off">
            <img className={styles.ico2} src={pointz} alt="" />{" "}
            <TextField
              className={styles.input}
              value={inputValue}
              onChange={handleInputChange}
              id="outlined-basic"
              label="Enter Number"
              variant="outlined"
              type="number"
              InputProps={{
                style: { color: "#C3E7FF", height: "40px" },
              }}
              InputLabelProps={{
                style: { color: "#C3E7FF" },
              }}
            />
          </Box>
        </>
      )}
    </BasePanel>
  );
};
export default LLG;
